/**
 * Request tracing utilities
 *
 * Provides functions for generating unique identifiers for distributed tracing.
 */

/**
 * Generates a unique trace ID for request tracking
 *
 * @returns A unique trace identifier string
 */
export function generateTraceId(): string {
  const randomString = Math.random().toString(36).substring(2, 16);
  return `trace-${randomString}`;
}
